import { useCallback } from 'react';
import { Category } from 'shared/types/product';
import { ProductQuery } from 'shared/types/query/ProductQuery';
import useSWR from 'swr';
import { sdk } from 'sdk';
import { Result } from 'shared/types/product/Result';
//import { revalidateOptions } from 'frontastic';
import { UseProductReturn } from './types';
import { recentlyViewed } from 'shared/types/account/Account';

const useProduct = (): UseProductReturn => {
  const { data } = useSWR('/action/product/queryCategories', () =>
    sdk.callAction<Result>({ actionName: 'product/queryCategories', query: { format: 'tree' } }),
  );

  const categories: Category[] | undefined = (data?.isError ? [] : (data?.data?.items as Category[])) ?? [];

  const query = useCallback(async (productQuery: ProductQuery) => {
    /* To Do: Use SDK instead of current workaround */

    const extensions = sdk.composableCommerce;

    const res = await extensions.product.query({
      limit: productQuery.limit,
      query: productQuery.query,
      slug: productQuery.slug,
    });

    return res;

    // const params = new URLSearchParams();

    // if (productQuery.query) params.set('query', productQuery.query);
    // if (productQuery.limit) params.set('limit', productQuery.limit);

    // const res = await fetchApiHub(`/action/product/query?${params.toString()}`, SDK.locale);

    // return { data: res, isError: false } as SDKResponse<Result>;
  }, []);
  const getProduct = useCallback(async (productQuery: string | undefined) => {
    const extensions = sdk.composableCommerce;

    const res = await extensions.product.getProduct({
      sku: productQuery,
    });
    return res;
  }, []);

  const addProductToCategory = useCallback(async (data: recentlyViewed) => {
    try {
      const response = await sdk.callAction<any>({
        actionName: 'product/addProductToCategory',
        payload: data,
      });
      return response;
    } catch (error) {
      console.error('Error adding product', error);
      throw error;
    }
  }, []);

  const QueryProductByCategoryKey = useCallback(async (categoryKey: string) => {
    try {
      const response = await sdk.callAction<any>({
        actionName: 'product/QueryProductByCategoryKey',
        payload: categoryKey,
      });
      return response;
    } catch (error) {
      console.error('Error getting product', error);
      throw error;
    }
  }, []);

  return { categories, query, addProductToCategory, QueryProductByCategoryKey, getProduct };
};

export default useProduct;
